import { render, staticRenderFns } from "./PublicTermsNConditions.vue?vue&type=template&id=2d0ec38a&"
import script from "./PublicTermsNConditions.vue?vue&type=script&lang=ts&"
export * from "./PublicTermsNConditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports